import axios from 'axios';
import {browserHistory} from 'react-router';
import {AUTH_USER,AUTH_ERROR,LOGOUT_USER,FETCH_POST,ADD_POST,POST_SHOW,DELETE_POST,EDIT_POST,UPDATE_POST,FETCH_USER,FETCH_PEOPLE,FETCH_UPLOADS,ADD_IMGS,FETCH_ADS,FETCH_PROMO_ADS,FETCH_SEARCH,FETCH_TRENDS,FETCH_LEADS,CLEAR_STATE,MYCART_PLACEORDER,FETCH_RZP_KEYS,FETCH_RECENT,FETCH_PRODUCT_TABS,FETCH_PRODUCT_DESC,FETCH_USER_ADDR} from './types';
const ROOT_URL = 'https://aquadeals.in/admin/web3/user/';
const BASE_URL = 'https://aquadeals.in/admin/web3/user/';
import querystring from 'querystring'; 

export function loginUser({email,password}){
  return function(dispatch){
      axios.post(`${ROOT_URL}api/login`,{email,password})
        .then(response => {
          dispatch({type: AUTH_USER,
            payload:{token:response.data.token}             
          });
          localStorage.setItem('token',response.data.token);
          browserHistory.push("/posts");
          window.location.reload();
        })
        .catch(()=>{
          dispatch(authError("Please provide valid details.. !"));
        });
  }

}

export function registerUser({name,email,password}){
    return function(dispatch){
        axios.post(`${ROOT_URL}api/register`,{name,email,password})
          .then(response =>{
            dispatch({type:AUTH_USER});
            localStorage.setItem('token',response.data.token);
            browserHistory.push('/posts');
            window.location.reload();
          })
          .catch(response => dispatch(authError(response.data.error)));

    }
}

export function addPost({title,body}){
  return function(dispatch){
    axios.post(`${ROOT_URL}api/posts`,{title,body},
      {
      headers:{authorization:localStorage.getItem('token')}
    })
    .then(response => {
      dispatch({
        type:ADD_POST,
        payload:response
      })
    })
  }
}

export function addPosting(img_url,post_title){
  return function(dispatch){
    axios.post(`${ROOT_URL}api/lib`,{img_url,post_title},
      {
      headers:{authorization:localStorage.getItem('token')}
    })
    .then(response => {
      dispatch({
        type:ADD_IMGS,
        payload:response
      })
    })
  }
}

export function fetchImages(){
  return function(dispatch){
    axios.get(`${ROOT_URL}api/lib`,
      {
      headers:{authorization:localStorage.getItem('token')}
    })
    .then(response => {
      dispatch({
        type:FETCH_UPLOADS,
        payload:response
      })
    })
  }
}

export function fetchPost(){
    return function(dispatch){
      axios.get(`${ROOT_URL}api/posts`,{
       headers: { authorization: localStorage.getItem('token') }
      })
        .then(response =>{
            dispatch({
              type:FETCH_POST,
              payload:response
            });
        })

    }
}

export function fetchUser(id){
    return function(dispatch){
      axios.get(`${ROOT_URL}api/auth/${id}`,{
       headers: { authorization: localStorage.getItem('token') }
      })
        .then(response =>{
            dispatch({
              type:FETCH_USER,
              payload:response
            });
        })

    }
}

export function fetchUploads(user_id){
    return function(dispatch){
      axios.get(`${ROOT_URL}api/lib/${user_id}`,{
       headers: { authorization: localStorage.getItem('token') }
      })
        .then(response =>{
            dispatch({
              type:FETCH_UPLOADS,
              payload:response
            });
        })

    }
}

export function discover(){
    return function(dispatch){
      axios.get(`${ROOT_URL}api/auth/`,{
       headers: { authorization: localStorage.getItem('token') }
      })
        .then(response =>{
            dispatch({
              type:FETCH_PEOPLE,
              payload:response
            });
        })

    }
}

export function PostShow(id){
    return function(dispatch){
      axios.get(`${ROOT_URL}api/posts/${id}`,{
       headers: { authorization: localStorage.getItem('token') }
      })
        .then(response =>{
            dispatch({
              type:POST_SHOW,
              payload:response
            });
        })

    }
}

export function EditPost(id){
    return function(dispatch){
      axios.get(`${ROOT_URL}api/posts/${id}/edit`,{
       headers: { authorization: localStorage.getItem('token') }
      })
        .then(response =>{
            dispatch({
              type:EDIT_POST,
              payload:response
            });
        })
    }
}

export function tokenCheck()
{
  console.log("token check function calling");
  // localStorage.removeItem('user_id');
  // localStorage.removeItem('token');
  // window.location.reload();
}

export function updatePost(id,{title,body}){
  return function(dispatch){
    axios.put(`${ROOT_URL}api/posts/${id}`,{title,body},
      {
      headers:{authorization:localStorage.getItem('token')}
    })
    .then(response => {
      dispatch({
        type:UPDATE_POST,
        payload:response
      })
    })
  }
}

export function deletePost(id){
    return function(dispatch){
      axios.delete(`${ROOT_URL}api/posts/${id}`,{
       headers: { authorization: localStorage.getItem('token') }
      })
        .then(response =>{
            dispatch({
              type:DELETE_POST,
              payload:response
            });
        })

    }
}

export function authError(error){
    return {
      type:AUTH_ERROR,
      payload:error
    }
}

export function logoutUser() {
  localStorage.removeItem('token');
  return { type: LOGOUT_USER };
}
export function mobileNumber({mobile}){
  return function(dispatch){
    if(localStorage.source)
      {
        var source=localStorage.getItem('source');
      }
      else
      {
        source='';
      }
      if(localStorage.campaign)
      {
        var campaign=localStorage.getItem('campaign');
      }
      else
      {
        campaign='';
      }
      if(localStorage.url_id)
      {
        var url_id=localStorage.getItem('url_id');
      }
      else
      {
        url_id='';
      }
      var data = querystring.stringify({
          req: JSON.stringify({from:'mobile_web','mobile': mobile,uid:localStorage.getItem('f_uid'),email:localStorage.getItem('f_email'),password:'',device_id:localStorage.getItem('push_device_id'),version:'',platform:'',language:'',source:source,campaign:campaign,url_id:url_id})
          });
      axios.post(`${ROOT_URL}social_mobile_auth`,data,{
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }})
          .then(response =>{
            dispatch({
              type:AUTH_USER,
              payload:response
            });
           if(response.data.status==='success' && response.data.page_source ==='dashboard'){
            localStorage.setItem('user_id',response.data.uid);
            localStorage.setItem('token',response.data.token);
            browserHistory.push('/home');
           }
           if(response.data.page_source === 'otp_screen'){
              browserHistory.push('/mobile/verify_otp');
              window.location.reload();
           }
      })
          .catch(response => dispatch(authError(response.data.error)));
    }
}

export function OTPsent({mobile}){

    if(typeof(window.location.pathname.split("/")[2])  === "undefined"){
         var redirect_url ='';
     }else{
        var redirect_url =window.location.pathname.split("/")[2];
     }

    return function(dispatch){
      if(localStorage.source)
      {
        var source=localStorage.getItem('source');
      }
      else
      {
        source='';
      }
      if(localStorage.campaign)
      {
        var campaign=localStorage.getItem('campaign');
      }
      else
      {
        campaign='';
      }
      if(localStorage.url_id)
      {
        var url_id=localStorage.getItem('url_id');
      }
      else
      {
        url_id='';
      }
      var data = querystring.stringify({
          req: JSON.stringify({from:'mobile_web','mobile': mobile,device_id:localStorage.getItem('push_device_id'),source:source,campaign:campaign,url_id:url_id})
          });
      axios.post(`${ROOT_URL}sentOtp`,data,{
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }})
          .then(response =>{
            dispatch({
              type:AUTH_USER,
              payload:response
            });
            localStorage.setItem('mobile_number',mobile);
            if(response.data.status === 'success' && response.data.page === 'login'){
              browserHistory.push('/account/'+redirect_url);
              // window.location.reload();
            }else if(response.data.status === 'success' && response.data.page === 'signup'){
              browserHistory.push('/signup');   
              // window.location.reload();
            }
          })
          .catch(response => dispatch(authError(response.data.error)));
    }
}

export function Otpverify({mobile,otp}){
    return function(dispatch){
      if(localStorage.source)
      {
        var source=localStorage.getItem('source');
      }
      else
      {
        source='';
      }
      if(localStorage.campaign)
      {
        var campaign=localStorage.getItem('campaign');
      }
      else
      {
        campaign='';
      }
      if(localStorage.url_id)
      {
        var url_id=localStorage.getItem('url_id');
      }
      else
      {
        url_id='';
      }
      var mobile = localStorage.getItem('mobile_number');
      var pwd = localStorage.getItem('pwd');
      var data = querystring.stringify({
          req: JSON.stringify({ 'from' : 'mobile_web',
                                'mobile': mobile,
                                'otp': otp,
                                'pwd': pwd,source:source,campaign:campaign,url_id:url_id
                                })
          });
      axios.post(`${ROOT_URL}verifyOtp`,data,{
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }})
          .then(response =>{
            dispatch({
              type:AUTH_USER,
              payload:response
            });
            console.log(response.data);  
            if(response.data.status === 'success'){
              localStorage.setItem('token',response.data.user[0].token);  
              browserHistory.push('/reset');
              // window.location.reload();
            }
          })
          .catch(response => dispatch(authError(response.data.error)));
    }
}

export function Signup({mobile,name,password,email,refcode,tnc}){
    return function(dispatch){
      var mobile = localStorage.getItem('mobile_number');
      if(localStorage.source)
      {
        var source=localStorage.getItem('source');
      }
      else
      {
        source='';
      }
      if(localStorage.campaign)
      {
        var campaign=localStorage.getItem('campaign');
      }
      else
      {
        campaign='';
      }
      if(localStorage.url_id)
      {
        var url_id=localStorage.getItem('url_id');
      }
      else
      {
        url_id='';
      }
      var data = querystring.stringify({
          req: JSON.stringify({ 'from' : 'mobile_web',
                                'mobile'  : mobile,
                               'name'    : name,
                               'password': password,
                               'email'   : email,
                               'referral': refcode,
                               'device': '',
                               'version': '',
                               'platform':'',
                               'device_id':localStorage.getItem('push_device_id'),source:source,campaign:campaign,url_id:url_id
                                })
          });
      axios.post(`${ROOT_URL}signup`,data,{
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }})
          .then(response =>{
            dispatch({
              type:AUTH_USER,
              payload:response
            });
            console.log(response.data);
            if(response.data.status === 'success'){
              browserHistory.push('/Otpverify');
            }
          })
          .catch(response => dispatch(authError(response.data.error)));
    }
}

//** Dec 8th 2016 **//


export function fetchads(){
    return function(dispatch){
      var uid = '';
      if(localStorage.user_id){
         uid = localStorage.user_id;  
      }
      else {
         uid = localStorage.ip;
      }
      if(localStorage.source)
      {
        var source=localStorage.getItem('source');
      }
      else
      {
        source='';
      }
      if(localStorage.campaign)
      {
        var campaign=localStorage.getItem('campaign');
      }
      else
      {
        campaign='';
      }
      if(localStorage.url_id)
      {
        var url_id=localStorage.getItem('url_id');
      }
      else
      {
        url_id='';
      }
      var data = querystring.stringify({
          req: JSON.stringify({
                                'id':uid,
                                'token':localStorage.getItem('token'),
                                'width'  : 400,
                                'height' : 200,
                                'from'   : 4,source:source,campaign:campaign,url_id:url_id
                                })
          });
      axios.post(`${ROOT_URL}getAd`,data,{
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }})
          .then(response =>{
            dispatch({
              type:FETCH_ADS,
              payload:response
            });
          })
          .catch(response => dispatch(authError(response.data.error)));
    }
}

export function ads_count(ad_id){
    return function(dispatch){
      var uid = '';
    if(localStorage.user_id){
       uid = localStorage.user_id;  
    }
    else{
       uid = localStorage.ip;
    } 
    if(localStorage.source)
      {
        var source=localStorage.getItem('source');
      }
      else
      {
        source='';
      }
      if(localStorage.campaign)
      {
        var campaign=localStorage.getItem('campaign');
      }
      else
      {
        campaign='';
      }
      if(localStorage.url_id)
      {
        var url_id=localStorage.getItem('url_id');
      }
      else
      {
        url_id='';
      }  
    var data = querystring.stringify({
          req: JSON.stringify({'from'  : 4,
                               'ad_id' : ad_id,
                               'id'   : uid,source:source,campaign:campaign,url_id:url_id
                                })
          });
      axios.post(`${ROOT_URL}load_ad`,data,{
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }})
          .then(response =>{
            dispatch({
              type:FETCH_ADS,
              payload:response
            });
          })
          .catch(response => dispatch(authError(response.data.error)));
    }
}


export function fetchpromo_ads(){
    return function(dispatch){
      axios.post(`${ROOT_URL}getOffers`)
          .then(response =>{
            dispatch({
              type:FETCH_PROMO_ADS,
              payload:response
            });
          })
          .catch(response => dispatch(authError(response.data.error)));
    }
}

export function search_products(keywords){
    return function(dispatch){
      if(localStorage.source)
      {
        var source=localStorage.getItem('source');
      }
      else
      {
        source='';
      }
      if(localStorage.campaign)
      {
        var campaign=localStorage.getItem('campaign');
      }
      else
      {
        campaign='';
      }
      if(localStorage.url_id)
      {
        var url_id=localStorage.getItem('url_id');
      }
      else
      {
        url_id='';
      }
      var data = querystring.stringify({
          req: JSON.stringify({from:'mobile_web','srh' : keywords,source:source,campaign:campaign,url_id:url_id})
          });
      axios.post(`${ROOT_URL}searchbybrand_product`,data,{
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }})
          .then(response =>{
            dispatch({
              type:FETCH_SEARCH,
              payload:response
            });
          })
          .catch(response => dispatch(authError(response.data.error)));
    }
}
export function placeorder(data2){
    return function(dispatch){
      var data = querystring.stringify({req: data2});
      axios.post(`${ROOT_URL}cartCalculations`,data,{
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }})
          .then(response =>{
            dispatch({
              type:MYCART_PLACEORDER,
              payload:response
            });
          })
          .catch(response => dispatch(authError(response.data.error)));
    }
}


export function saveseed_lead({name,number,email},seller_id,deal_id){
    return function(dispatch){
      if(localStorage.source)
      {
        var source=localStorage.getItem('source');
      }
      else
      {
        source='';
      }
      if(localStorage.campaign)
      {
        var campaign=localStorage.getItem('campaign');
      }
      else
      {
        campaign='';
      }
      if(localStorage.url_id)
      {
        var url_id=localStorage.getItem('url_id');
      }
      else
      {
        url_id='';
      }
      var data = querystring.stringify({
          req: JSON.stringify({ 'from' : 'mobile_web',
                                'name' : name,
                                'mobile': number,
                                 'email': email,
                                 'seller_id': seller_id,
                                 'deal_id' : deal_id,source:source,campaign:campaign,url_id:url_id

                               })
          });
      axios.post(`${ROOT_URL}saveseed_lead_web`,data,{
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }})
          .then(response =>{
            dispatch({
              type:FETCH_LEADS,
              payload:response
            });
          })
          .catch(response => dispatch(authError(response.data.error)));
    }
}

export function savefeed_lead({name,number,email},seller_id,deal_id){
    return function(dispatch){
      if(localStorage.source)
      {
        var source=localStorage.getItem('source');
      }
      else
      {
        source='';
      }
      if(localStorage.campaign)
      {
        var campaign=localStorage.getItem('campaign');
      }
      else
      {
        campaign='';
      }
      if(localStorage.url_id)
      {
        var url_id=localStorage.getItem('url_id');
      }
      else
      {
        url_id='';
      }
      var data = querystring.stringify({
          req: JSON.stringify({  'from' : 'mobile_web',
                                 'name' : name,
                                 'mobile': number,
                                 'email': email,
                                 'seller_id': seller_id,
                                 'deal_id' : deal_id,source:source,campaign:campaign,url_id:url_id
                               })
          });
      axios.post(`${ROOT_URL}savefeed_lead_web`,data,{
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }})
          .then(response =>{
            dispatch({
              type:FETCH_LEADS,
              payload:response
            });
          })
          .catch(response => dispatch(authError(response.data.error)));
    }
}

export function trends(){
    return function(dispatch){
      if(localStorage.user_id)
      {
        var uid=localStorage.user_id;
      }
      else
      {
        uid=0;
      }
      var data = querystring.stringify({req: JSON.stringify({ 'from':'mobile_web',uid:uid})});
      axios.post(`${ROOT_URL}getTrends`,data,{
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }})
          .then(response =>{
            dispatch({
              type:FETCH_TRENDS,
              payload:response
            });
          })
          .catch(response => dispatch(authError(response.data.error)));
    }
}

export function track_seller_lead({name,number,email,company_name},from,user_mobile,user_name,seller_id,deal_id,stype,role,message){
    return function(dispatch){
      var id = '';
      if(localStorage.user_id){
         id = localStorage.user_id;  
      }
      else {
         id = localStorage.ip;
      }
      var token='';
      if(localStorage.token){
        token=localStorage.token;
      }
      else{
        token=0;
      }
      if(localStorage.source)
      {
        var source=localStorage.getItem('source');
      }
      else
      {
        source='';
      }
      if(localStorage.campaign)
      {
        var campaign=localStorage.getItem('campaign');
      }
      else
      {
        campaign='';
      }
      if(localStorage.url_id)
      {
        var url_id=localStorage.getItem('url_id');
      }
      else
      {
        url_id='';
      }
      var data = querystring.stringify({
          req: JSON.stringify({ 'from' : from,
                                'id' : id,
                                'token': token,
                                'name' : user_name,
                                'mobile': user_mobile,
                                'email': email,
                                'cname':company_name,
                                'stype':stype,
                                'role':role,
                                'message':message,
                                'seller_id': seller_id,
                                'deal_id' : deal_id,source:source,campaign:campaign,url_id:url_id
                               })
          });
      axios.post(`${ROOT_URL}trackSellerLead`,data,{
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }})
          .then(response =>{
            dispatch({
              type:FETCH_LEADS,
              payload:response
            });
            // browserHistory.push('/customer_care_seller');
            // window.location.reload();
            if(response.message === '1'){
              browserHistory.push('/customer_care_seller');
              // window.location.reload();
            }
          })
          .catch(response => dispatch(authError(response.data.error)));
    }
}


export function track_user_lead({name,number,email},dtype){
     var mail='';
     if(email.lenght >0){
      mail=email;
     }
     else {
      mail='';
    }
    // alert(email);

    return function(dispatch){
      if(localStorage.source)
      {
        var source=localStorage.getItem('source');
      }
      else
      {
        source='';
      }
      if(localStorage.campaign)
      {
        var campaign=localStorage.getItem('campaign');
      }
      else
      {
        campaign='';
      }
      if(localStorage.url_id)
      {
        var url_id=localStorage.getItem('url_id');
      }
      else
      {
        url_id='';
      }
      var data = querystring.stringify({
          req: JSON.stringify({ 'from' : 'mobile_web',
                                'name' : name,
                                'mobile': number,
                                 'email': mail,
                                 'dtype': dtype,source:source,campaign:campaign,url_id:url_id
                                })
          });
      axios.post(`${ROOT_URL}trackUserLead`,data,{
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }})
          .then(response =>{
            dispatch({
              type:FETCH_LEADS,
              payload:response
            });
            if(response.data.status === 'success'){
              browserHistory.push('/customer_care');
              // window.location.reload();
            }
          })
          .catch(response => dispatch(authError(response.data.error)));
    }
}

export function get_rzp_keys(source){
    return function(dispatch){
      var data = querystring.stringify({req: JSON.stringify({ 'from':source})});
      axios.post(`${ROOT_URL}getRazorpayKeys`,data,{
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }})
          .then(response =>{
            dispatch({
              type:FETCH_RZP_KEYS,
              payload:response
            });
          })
          .catch(response => dispatch(authError(response.data.error)));
    }
}

export function recommendedforyou(source){
    return function(dispatch){
      var uid = localStorage.user_id;  
      var data = querystring.stringify({req: JSON.stringify({ 'from':'mobile_web',uid:uid})});
      axios.post(`${ROOT_URL}recommendedforyou`,data,{
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }})
          .then(response =>{
            dispatch({
              type:FETCH_RECENT,
              payload:response
            });
          })
          .catch(response => dispatch(authError(response.data.error)));
    }  
}

export function getProductTabs(params){
    return function(dispatch){
      var uid = localStorage.user_id;  
      var data = querystring.stringify({req: JSON.stringify({ 'from':'mobile_web',pid:params,uid:uid})});
      axios.post(`${ROOT_URL}getTabs`,data,{
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }})
          .then(response =>{
            dispatch({
              type:FETCH_PRODUCT_TABS,
              payload:response
            });
          })
          .catch(response => '');
    }  
}

export function getProductDesc(pid,cid){
    return function(dispatch){
      var uid = localStorage.user_id;  
      var data = querystring.stringify({req: JSON.stringify({ 'from':'mobile_web',pid:pid,cid:cid,uid:uid})});
      axios.post(`${ROOT_URL}getTabsdesc`,data,{
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }})
          .then(response =>{
            dispatch({
              type:FETCH_PRODUCT_DESC,
              payload:response
            });
          })
          .catch(response => dispatch(authError(response.data.error)));
    }  
}

export function getUserAddress(data){
    return function(dispatch){
      var params = querystring.stringify({req: data});
      axios.post(`${ROOT_URL}getuserAddress`,params,{
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }})
          .then(response =>{
            dispatch({
              type:FETCH_USER_ADDR,
              payload:response
            });
          })
          .catch(response => dispatch(authError(response.data.error)));
    }  
}

export function clear_state() {
  return { type: CLEAR_STATE };
}


/** WEBPACK FOOTER **
 ** ./src/actions/index.js
 **/